import { Modal } from 'antd';

import styled from 'styled-components';

export const ModalContainer = styled(Modal)<{ isConfirm?: boolean }>`
  .ant-modal-body {
    ${({ isConfirm }) => (isConfirm ? '' : 'height: 500px')};
    overflow-y: auto;
  }
`;

export const Container = styled.div`
  p {
    font-size: 14px;
    font-weight: 500;
    color: #202020;
  }
`;

export const radioWrapper = styled.div`
  margin-bottom: 32px;

  p {
    margin-bottom: 16px;
  }

  .ant-radio-wrapper {
    margin-right: 48px;
  }

  .ant-radio-disabled.ant-radio-checked {
    .ant-radio-inner {
      border-color: #2d3f86;
      background-color: #2d3f86;
    }
    .ant-radio-inner::after {
      border: 1px solid #2d3f86;
      background-color: white;
    }
  }
`;
